import { render, staticRenderFns } from "./SetBook.vue?vue&type=template&id=36e92667&"
import script from "./SetBook.vue?vue&type=script&lang=js&"
export * from "./SetBook.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports